(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/games-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/games-abtest.js');
'use strict';

const _svs$ui$ReactForm = svs.ui.ReactForm,
  ControlGroup = _svs$ui$ReactForm.ControlGroup,
  Option = _svs$ui$ReactForm.Option,
  Radio = _svs$ui$ReactForm.Radio;
const poolsVerticalHelpText = svs.self_exclusion_react.data.poolsVerticalHelpText;
const games = svs.selfExclusion.allGamesAbTest.games;
const GamesAbTest = _ref => {
  let onHandleGame = _ref.onHandleGame,
    game = _ref.game,
    isSubmitted = _ref.isSubmitted;
  const handleChange = checkedItem => {
    onHandleGame(checkedItem !== null ? checkedItem.value : null);
  };
  return React.createElement(ControlGroup, {
    className: "question-header-text",
    errorMessage: "Du m\xE5ste v\xE4lja ett spel",
    hasError: isSubmitted && !game,
    v2: true
  }, React.createElement("fieldset", {
    "aria-labelledby": "self-exclusion-header game-selection-label"
  }, React.createElement("legend", {
    className: "question-header-text",
    id: "game-selection-label"
  }, "V\xE4lj vad du vill pausa dig fr\xE5n "), React.createElement(Option, null), games.map(mappedGame => React.createElement("div", {
    className: "padding-bottom-1 question-body-text",
    key: mappedGame.id
  }, React.createElement(Radio, {
    checked: game === mappedGame.value,
    key: mappedGame.id,
    name: "game",
    onChange: () => handleChange(mappedGame),
    value: mappedGame.value
  }, mappedGame.label)))), poolsVerticalHelpText && React.createElement("p", {
    className: "help-text indent-helptext question-body-text"
  }, "* Stryktipset, Europatipset, Topptipset, M\xE5ltipset, H\xE4star, Challenge, Powerplay, Bomben och Matchen."));
};
svs.selfExclusion.components.GamesAbTest = GamesAbTest;

 })(window);